<template>
  <transition name="el-fade-in-linear">
    <div class="pop" v-if="showPropPop" @click.self="hide">
      <div class="selectPopProp">
        <div class="popRoot">
          <span
            style="margin-top: 0.1083rem;color: #fff; font-size: 0.1146rem; margin-bottom: 0.1563rem;"
            >选择上传品类</span
          >

          <img src="/static/images/close.png" class="popClose" @click="hide" />
          <div class="propTabs">
            <button
              v-for="item in propTabs"
              :class="item == propDetail ? 'selTabBtn' : 'TabBtn'"
              @click="selectTab(item)"
              v-bind:key="item.id"
            >
              {{ item.caseTypeName }}
            </button>
          </div>
          <div class="tabDivider"></div>
          <div class="propGrid">
            <button
              v-for="item in propDetail.classList"
              :class="caseTypeId == item.id ? 'selTabBtn' : 'TabBtn'"
              v-bind:key="item.id"
              @click="selectCaseTypeId(item.id)"
            >
              {{ item.caseTypeName }}
            </button>
          </div>

          <div style="align-self: flex-start;padding-left: 0.5508rem;">
            <span style="color: #fff; font-size: 0.1146rem; ">添加标签</span>
          </div>
          <div class="tabDivider"></div>
          <div class="propTagGrid">
            <button
              :class="item.isSlected ? 'selTabTagBtn' : 'TabTagBtn'"
              v-for="item in labelList"
              @click="addTag(item)"
              v-bind:key="item.id"
            >
              {{ item.caseLabelName }}
            </button>
          </div>

          <div
            class="selTabBtn"
            style="margin-top: 0.1563rem;"
            @click="uploadCase"
          >
            上传案例
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  getUploadCaseFlag,
  getCaseTypeList,
  getCaseLabelList,
  uploadCase
} from "@/api/ai/userAiChatType.js";
import { upload } from "@/utils/upload";

export default {
  name: "uploadWork",

  // @ApiModelProperty(value = "垫图")
  // private String imageMessageUrl;
  // @ApiModelProperty(value = "提示词")
  // private String message;
  // @ApiModelProperty(value = "展示效果图")
  // private String replyMessage;
  // @ApiModelProperty(value = "参数配置信息")
  // private String subText;
  // @ApiModelProperty(value = "操作类型")
  // private String action;
  // @ApiModelProperty(value = "初始操作类型")
  // private Integer actionType;
  // prop: {
  //     imageMessageUrl: {
  //         type: String,
  //         default: null
  //     },
  //     message: {
  //         type: String,
  //         default: null
  //     },
  //     replyMessage: {
  //         type: String,
  //         default: null
  //     },
  //     subText: {
  //         type: String,
  //         default: null
  //     },
  //     action: {
  //         type: String,
  //         default: null
  //     },
  //     actionType: {
  //         type: String,
  //         default: null
  //     }
  // },
  data() {
    return {
      propTabs: [],
      propDetail: [],
      showPropPop: false,
      workImageUrl: null,
      curentTags: [],
      labelList: [],
      caseTypeId: undefined
    };
  },
  computed: {},
  destroyed() {},
  mounted() {
    //  console.log('ssssssssssssssss')
    // 获取数据
    getUploadCaseFlag().then(res => {
      console.log(res);
    });
    getCaseTypeList().then(res => {
      console.log(res);
      const d = res.data;
      for (const item of d) {
        const o1 = {};
        o1.caseTypeName = item.caseTypeName;
        o1.classList = [];
        o1.id = item.id;
        this.propTabs.push(o1);
        for (const cit of item.userCaseTypeVoList) {
          o1.classList.push(cit);
        }
        this.$nextTick(() => {
          this.propDetail = this.propTabs[0];
        });
      }
      getCaseLabelList({ caseTypeId: this.propTabs[0].id }).then(res => {
        this.labelList = res.data;
      });
    });
  },
  watch: {
    showPropPop(newval) {
      this.labelList.forEach(item => {
        this.caseTypeId = undefined;
        item.isSlected = false;
      });
    }
  },
  methods: {
    addTag(item) {
      item.isSlected = !item.isSlected;
      this.$forceUpdate();
    },
    selectCaseTypeId(id) {
      this.caseTypeId = id;
    },
    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(",")[1]);
      const mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
      }

      return new Blob([arrayBuffer], { type: mimeString });
    },
    uploadToFile(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          const canvas1 = document.createElement("canvas");
          const ctx1 = canvas1.getContext("2d");

          // 设置canvas的宽度和高度与图片相同
          canvas1.width = img.width;
          canvas1.height = img.height;
          ctx1.drawImage(img, 0, 0, img.width, img.height);

          const f = this.dataURItoBlob(canvas1.toDataURL("image/png"));
          const file = { file: new File([f], "aa.png", { type: "image/png" }) };

          upload(file).then(res => {
            resolve(res);
          });
        };
        img.src = url;
      });
    },
    async uploadCase() {
      if (!this.caseTypeId) {
        this.$message("请选择品类 ");
        return;
      }
      this.hide();
      //处理图片上传

      if (this.workImageUrl) {
        //处理图片上传
        if (this.workImageUrl.indexOf("?") != -1) {
          this.workImageUrl = await this.uploadToFile(this.workImageUrl);
        }
      }
      // 处理
      const obj = {
        caseTypeId: this.caseTypeId,
        albumContentId: this.albumContentId,
        chatContentId: this.cid,
        caseLabelIds: this.labelList
          .filter(it => it.isSlected)
          .map(it => it.id),
        indexes: [this.index],
        workImageUrl: this.workImageUrl ? this.workImageUrl : undefined
      };
      this.workImageUrl = null;

      this.caseTypeId = undefined;
      uploadCase(obj).then(res => {
        this.$message({
          type: "success",
          message: "案例上传成功,审核通过后即可显示在案例广场"
        });
      });
    },

    selectTab(item) {
      this.propDetail = item;
      getCaseLabelList({
        caseTypeId: item.id
      }).then(res => {
        this.labelList = res.data;
      });
    },
    open(item) {
      this.cid = item.id;
      this.albumContentId = item.workId;
      this.workImageUrl = item.workImageUrl;
      this.index = item.caseIndex - 1;
      this.showPropPop = true;
    },
    hide() {
      this.showPropPop = false;
    },
    sendMsgTime() {
      if (this.smsState && this.smsState.sendTime) {
        if (this.timeOut) {
          clearTimeout(this.timeOut);
        }
        this.leftTime = parseInt(
          this.smsState.sendTime.getTime() / 1000 +
            60 -
            new Date().getTime() / 1000
        );
        this.timeOut = setTimeout(() => {
          const lastLeftTime = this.leftTime;
          this.leftTime = parseInt(
            this.smsState.sendTime.getTime() / 1000 +
              60 -
              new Date().getTime() / 1000
          );
          if (lastLeftTime !== this.leftTime) {
            this.$emit("change", this.leftTime);
          }
          if (this.leftTime > 0) {
            this.sendMsgTime();
          }
        }, 200);
      }
    }
  }
};
</script>

<style scoped>
.selectPopProp {
  width: 70%;
  background: #141825;
  height: 85%;
  border-radius: 13px;
  border: 1px solid;
  position: absolute;
  left: 15%;
  right: 15%;
  top: 2%;
}

.propGrid::-webkit-scrollbar {
  display: none;
}
button {
  outline: none;
  color: white;
  border: none;
  padding: 0;
  font-size: 16px;
  margin: 0;
  background: none;
  background-image: none;
}

.propTabs {
  width: calc(100% - 110px - 110px);
  padding-left: 110px;
  padding-right: 110px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.selTabBtn {
  background: none;
  background: #03aff4;
  border-radius: 24px;
  padding-left: 25px;
  height: 48px;
  padding-right: 25px;
  margin-right: 15px;
  font-size: 18px;
  line-height: 48px;
}
.selTabTagBtn {
  background: #03aff4;
  border-radius: 24px;
  padding-left: 15px;
  margin-top: 10px;
  height: 38px;
  padding-right: 15px;
  margin-right: 10px;
  font-size: 16px;
  line-height: 38px;
}

.popClose {
  position: absolute;
  right: 30px;
  top: 14px;
  width: 18px;
  height: 18px;
}

.TabBtn {
  background: none;
  background: #000000;
  border-radius: 24px;
  padding-left: 25px;
  height: 48px;
  padding-right: 25px;
  margin-right: 15px;
  font-size: 18px;
  line-height: 48px;
}
.TabTagBtn {
  background: none;
  background: #000000;
  border-radius: 24px;
  padding-left: 15px;
  margin-top: 10px;
  height: 38px;
  padding-right: 15px;
  margin-right: 10px;
  font-size: 16px;
  line-height: 38px;
}

.TabBtn:hover {
  background: none;
  background: #03aff4;
  border-radius: 24px;
  padding-left: 25px;
  height: 48px;
  padding-right: 25px;
  margin-right: 15px;
  font-size: 18px;
  line-height: 48px;
}

.popRoot {
  width: 100%;
  height: 100%;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 15px;
  color: #ffffff;
  position: relative;
}

.selTabBtn {
  background: none;
  background: #03aff4;
  border-radius: 24px;
  padding-left: 25px;
  height: 48px;
  padding-right: 25px;
  margin-right: 15px;
  font-size: 18px;
  line-height: 48px;
}

.TabBtn {
  background: none;
  background: #000000;
  border-radius: 24px;
  padding-left: 25px;
  height: 48px;
  padding-right: 25px;
  margin-right: 15px;
  font-size: 18px;
  line-height: 48px;
}

.TabBtn:hover {
  background: none;
  background: #03aff4;
  border-radius: 24px;
  padding-left: 25px;
  height: 48px;
  padding-right: 25px;
  margin-right: 15px;
  font-size: 18px;
  line-height: 48px;
}

.propGrid {
  display: grid;
  width: calc(100% - 100px - 100px);
  padding-left: 100px;
  padding-right: 100px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
  padding: 10px;
  box-sizing: border-box;
  max-height: 100%;
}
.propTagGrid {
  display: flex;
  width: calc(100% - 100px - 100px);
  flex-wrap: wrap;
}

.tabDivider {
  width: calc(100% - 110px - 110px);
  height: 1px;
  margin-left: 110px;
  margin-right: 110px;
  background: #03b0f492;
  margin-top: 6px;
  margin-bottom: 6px;
}

.modelItem {
  width: 164px;
  position: relative;
  height: 164px;
}

.modelSpan {
  position: absolute;
  width: 145px;
  height: 30px;
  line-height: 30px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  bottom: 40px;
}

/* .propGrid button {
  border: 1px solid transparent;
  color: #fff;
  height: 48px;
  border-radius: 8px;
  background: #0f131e;
}

.propGrid button:hover {
  border: 1px solid transparent;
  color: #fff;
  height: 48px;
  background: #2b3657;
  border-radius: 8px;
}

.propGrid button.sel {
  border: 1px solid transparent;
  color: #fff;
  height: 48px;
  background: #2b3657;
  border-radius: 8px;
  border: 1px solid #1fd5ff;
} */
</style>



// WEBPACK FOOTER //
// src/components/uploadWorkPop/index.vue